module.exports = __webpack_public_path__ + "img/ideation-02-bg-intro-transparent.2057bc44.png";